import clsx from "clsx";
import { Link } from "react-router-dom";
import { BrandingLogo } from "@/components/branding/BrandingLogo";
import { useBranding } from "@/lib/branding/useBranding";

type SiteBrandMarkProps = {
  to?: string;
  showName?: boolean;
  className?: string;
  nameClassName?: string;
  collapsed?: boolean;
  siteName?: string;
  logoUrl?: string | null;
};

/** Logo und optional Anzeigename des Campingplatzes. */
export function SiteBrandMark({
  to = "/",
  showName = true,
  className,
  nameClassName,
  collapsed = false,
  siteName: siteNameProp,
  logoUrl: logoUrlProp,
}: SiteBrandMarkProps) {
  const ctx = useBranding();
  const siteName = siteNameProp ?? ctx.siteName;
  const content = (
    <>
      <BrandingLogo
        logoUrl={logoUrlProp}
        siteName={siteName}
        imgClassName={collapsed ? "h-7 max-w-[2.5rem]" : "h-8 max-w-[9rem]"}
        fallbackClassName={collapsed ? "text-lg" : "text-2xl"}
      />
      {showName && !collapsed ? (
        <span className={clsx("min-w-0 truncate font-bold text-accent", nameClassName)}>
          {siteName}
        </span>
      ) : null}
    </>
  );

  const classes = clsx("flex min-w-0 items-center gap-2", className);

  if (to) {
    return (
      <Link
        to={to}
        className={classes}
        aria-label={`${siteName} – Startseite`}
      >
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content}</div>;
}
